module.exports = __webpack_public_path__ + "static/logo-1230292b1ffa6c3be45e5891c3d3029c.svg";